import * as React from "react";
import { AppState, store, Actions, IPageState } from '../../appredux';
import { connect } from 'react-redux';
import { Theme, withStyles, WithStyles, Typography, FormControl, Grid, Button, TextField } from '@material-ui/core';

import ZamowieniaTabela from "./ZamowieniaTabela";
import { SerwisService, Result, FakturaVatService, VatTableRowFromTo } from "../../api";
import Ladowanie, { NoResult } from "./Ladowanie";
import Pagination, { calculateRange } from "./Pagination";
import CONFIG from "../../cfg/config";
import { useCallback } from "react";

import './style.css'

interface HotelProps extends WithStyles<typeof styles> {
    page: IPageState,

    width: number,

    serwisHotelTablica: VatTableRowFromTo[],
    setSerwisHotelTablica: (VatTableRowFromTo: VatTableRowFromTo[], tel: number) => void,

    serwisHotelIlosc: number,
    setSerwisHotelIlosc: (ilosc: number) => void,

    paginacjaHotel: number[], //[skip, page, rowsPerPage]
    setPaginacjaHotel: (paginacja: number[]) => void,

    selectStatus: (status: VatTableRowFromTo) => void,
    addToCart: (aDokNr: string) => void,
    telefon: number

}

interface HotelState {
    ladowanie: boolean,
    telefonNumer: number,
    error: boolean
}

class Hotel extends React.Component<HotelProps, HotelState>  {
    stylInputaRezerwacja: React.CSSProperties = { padding: "8px 14px", textAlign: "left", fontWeight: "bold", fontSize: "1rem" };

    constructor(props: HotelProps) {
        super(props, {});
        this.state = {
            //ladowanie: this.props.serwisHotelTablica.length === 0 ? true : false,
            ladowanie: false,
            telefonNumer: this.props.telefon,
            error: false
        }
    }

    //PM 2021-10-25
    //podlaczenie do API
    async componentDidMount() {
        let el = document.getElementById("zamowieniaTextField") as HTMLInputElement
        if(el) {
            setTimeout(() =>{
                el.focus()
            }, 10)
        }

        //if(this.props.load){
            // await this.dajSerwisHotelIlosc()
            // this.props.setPaginacjaHotel([0, 1, this.props.paginacjaHotel[2]])
            // await this.dajSerwisHotel(1, this.props.paginacjaHotel[2]);
        //}  
    }


    getTelefonNumer = (event: React.ChangeEvent<{ name?: string; value: unknown; }>) => {
        this.setState({ telefonNumer: Number(event.target.value) })
        this.stylInputaRezerwacja = { ...this.stylInputaRezerwacja, backgroundColor: "rgb(232, 240, 254)" };
      }

      search = async() => {
        await this.dajTabelaIlosc()
        this.props.setPaginacjaHotel([0, 1, this.props.paginacjaHotel[2]])
        await this.dajTabela(1, this.props.paginacjaHotel[2]);
      }

    // async componentDidUpdate(prevProps: HotelProps) {
    //     if(this.props.refresh !== prevProps.refresh) {
    //         await this.dajSerwisHotelIlosc()
    //         await this.dajSerwisHotel(this.props.paginacjaHotel[0] + 1, this.props.paginacjaHotel[0] + this.props.paginacjaHotel[2]);
    //     }
    // }


    dajTabelaIlosc = async () => {
        try {
            this.setState({ ladowanie: true })

            //const serwisHotelIlosc = await SerwisService.dajSerwisHotelIlosc()
            
            //this.props.setSerwisHotelIlosc(serwisHotelIlosc.result[0])
            this.props.setSerwisHotelIlosc(3)
            this.setState({ ladowanie: false })
        } catch (error) {
            console.log(error);
        }
    }

    // dajSerwisHotelUkryteIlosc = async () => {
    //     try {
    //         const serwisHotelUkryteIlosc = await SerwisService.dajSerwisHotelUkryteIlosc()

    //         await store.dispatch(Actions.pageState.setSerwisHotelUkryteIlosc(serwisHotelUkryteIlosc.result[0]));
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }

    dajTabela = async (start: number = 1, end: number = 10) => {
        try {
            this.setState({ ladowanie: true })

            // let res = await  FakturaVatService.getTableRowsFromTo({
            //     hotelId: "kelner-TEST-1",
            //     dataWystOd: "2022-03-21",
            //     dataWystDo: '2022-03-21'
            // })
            let res = await  FakturaVatService.getTableRowsPhone({
                hotelId: CONFIG.hotelID,
                telefon: this.state.telefonNumer.toString()
            })

            let err = res.result === null || res.result.length === 0

            this.setState({ ladowanie: false, error: err})
            this.props.setSerwisHotelTablica(res.result === null ? [] : res.result, this.state.telefonNumer) 
            // this.props.setSerwisHotelTablica([
            //     {data: "2022-03-09 wtorek", kwota: "23.00", zamowienie: "barszcz czerwony, frytki, ćwikła..."  },
            //     {data: "2022-03-08 poniedziałek", kwota: "23.00", zamowienie: "barszcz czerwony, frytki, ćwikła..."  },
            //     {data: "2022-03-03 środa", kwota: "23.00", zamowienie: "barszcz czerwony, frytki, ćwikła..."  } 
            // ]) //serwisHotel.result

        } catch (error) {
            console.log(error);
        }
    }

    // ukryjHotel = async (hotel: SerwisHotel) => {
    //     if(this.props.zakladkaHotel !== "4") { //ukryj
    //         await SerwisService.dajSerwisHotelDoLikwidacji({ hotelId: hotel.hotelId, doLikw: true })
    //         await store.dispatch(Actions.pageState.setSerwisHotelIlosc(this.props.serwisHotelIlosc -1));
    //         await store.dispatch(Actions.pageState.setSerwisHotelUkryteIlosc(this.props.serwisHotelUkryteIlosc +1));
    //     } else { //przywróć
    //         await SerwisService.dajSerwisHotelDoLikwidacji({ hotelId: hotel.hotelId, doLikw: false })
    //         await store.dispatch(Actions.pageState.setSerwisHotelIlosc(this.props.serwisHotelIlosc +1));
    //         await store.dispatch(Actions.pageState.setSerwisHotelUkryteIlosc(this.props.serwisHotelUkryteIlosc -1));
    //     }
        
       
    //     await this.dajSerwisHotel(this.props.paginacjaHotel[0] + 1, this.props.paginacjaHotel[0] + this.props.paginacjaHotel[2]  );
    // }

    // setRodzajSortowania = async (rodzaj: string) => {
    //     this.setState({ ladowanie: true })
    //     await store.dispatch(Actions.pageState.setPaginacjaHotel([0, 1, this.props.paginacjaHotel[2]]));
    //     await store.dispatch(Actions.pageState.setZakladkaHotel(rodzaj));
    //     if(rodzaj === "4" && this.props.serwisHotelUkryteIlosc === 0 ){
    //         this.dajSerwisHotelUkryteIlosc()
    //     }
    //     this.dajSerwisHotel( 1, this.props.paginacjaHotel[2])
    // }

    updateSkip = async (aPage: number) => {
        const newSkip = (aPage - 1) * this.props.paginacjaHotel[2]

        this.props.setPaginacjaHotel([newSkip, aPage, this.props.paginacjaHotel[2]])
        this.dajTabela(newSkip +1, newSkip + this.props.paginacjaHotel[2])
    }

    changeRowsPerPage = async (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        this.props.setPaginacjaHotel([0, 1, Number(event.target.value)])
        this.dajTabela(1, Number(event.target.value))
    }
    

    //PM 2021-10-21
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    //przerzucenie ladowania do tego komponentu
    render = () => {
        const { classes } = this.props;

        //let ilosc = this.props.zakladkaHotel !== "4" ? this.props.serwisHotelIlosc: this.props.serwisHotelUkryteIlosc
        let ilosc = this.props.serwisHotelIlosc
        const range = calculateRange(ilosc, this.props.paginacjaHotel[2])

        //let err = !this.state.TelefonNumer.replace(/\s/g, "").match(/(^\+\d{11,}$)|(^\d{9,}$)/)
        let err = this.state.telefonNumer.toString() !== "0" && !this.state.telefonNumer.toString().replace(/\s/g, "").match(/(^\d{11,12}$)|(^\d{9,9}$)/)
        let disabled = this.state.telefonNumer.toString() === "" || !this.state.telefonNumer.toString().replace(/\s/g, "").match(/(^\d{11,12}$)|(^\d{9,9}$)/)

        return (
            <div className={classes.container} style={{ width: '100%' }}>
              <Grid item style={{ width: "100%" }}> 
            <Typography variant="h6" component="h2" color="primary" align="center" style={{paddingBottom: "20px", fontSize: "1.25rem"}}>
              <b>HISTORIA ZAMÓWIEŃ</b>
            </Typography>
            </Grid>

          <div style={{textAlign: "center" ,paddingBottom: "20px"}}>
            <Typography gutterBottom variant="h5" component="span" color="primary" className={`${classes.padding}`}>
              <b>{"telefon nr"}</b>
            </Typography>
            <TextField 
              id="zamowieniaTextField"
              type="number"
              autoFocus
              name="phone"
              //placeholder="* * * * * * * * *"
              style={{ width: window.innerWidth < 600 ? "40%" : "25%", minWidth: "170px" }}
              inputProps={{ style: this.stylInputaRezerwacja }}
              InputProps={{ classes: { input: `${classes.primaryTextField} ${classes.font}` } }}
              defaultValue={this.state.telefonNumer === 0 ? "" : this.state.telefonNumer}
              onChange={this.getTelefonNumer}
              variant="outlined"
              error={err}
              helperText={err ? "Niepoprawny numer telefonu" : ""}
            />
            <Button variant="contained" color="primary" size="small"
              style={{ textTransform: "none", fontSize: "1rem", marginLeft: "8px", padding: "3px 10px 4px" }}
              disabled={disabled}
              onClick={this.search}
            >
              <b>OK</b>
            </Button>
            {/* 350636 350633 350637 */}
          </div>
                {/* <FormControl component="fieldset" variant="outlined" fullWidth margin='normal' className={classes.fieldset}>
                    <Grid container direction="row" alignItems='center'>
                        {[
                            { value: '1', text: 'Alfabet' },
                            { value: '2', text: 'Awarie' },
                            { value: '3', text: 'Zapisy' },
                            { value: '4', text: 'Ukryte' },
                        ].map((rn, index) => {
                            return (
                                <Grid key={rn.value} item className={classes.gridButton}>
                                    <Button
                                        style={{ width: this.props.width > 800 && index !== 3 ? "calc(100% + -3px)" : "100%", }}
                                        className={`${classes.input} ${this.props.zakladkaHotel === rn.value ? classes.primaryBackground : classes.seagreen}`}
                                        variant="outlined" color="primary"
                                        onClick={async () => await this.setRodzajSortowania(rn.value)}
                                    >
                                        {rn.text}
                                    </Button>
                                </Grid>
                            )
                        })}
                    </Grid>
                </FormControl> */}
                {this.state.ladowanie ?
                    <Ladowanie /> :
                    this.props.serwisHotelTablica.length ?
                        <>
                            <ZamowieniaTabela tableBody={this.props.serwisHotelTablica}  selectStatus={this.props.selectStatus}  addToCart={this.props.addToCart}/> {/*ukryjHotel={this.ukryjHotel}*/}
                            {/* <Pagination
                                page={this.props.paginacjaHotel[1]}
                                range={range}
                                updateSkip={this.updateSkip}
                                changeResultsPerPage={this.changeRowsPerPage}
                                resultsPerPage={this.props.paginacjaHotel[2]}
                                tableLength={ilosc}
                            /> */}
                        </> : this.state.error ? <NoResult/> : null}
                   
            </div>
        )
    }
}

const styles = (theme: Theme) => ({
    fieldset: {
        marginBottom: '18px'
    },
    container: {
        margin: 'auto',
    },
    gridButton: {
        width: 'calc((100% )/4)',
        "@media screen and (max-width: 800px)": {
            width: "100%"
        },
    },
    input: {
        border: "2px solid lavender",
        borderRadius: "0px",
        fontSize: "14px",
        lineHeight: "14px",
        fontWeight: "bold" as "bold",
        textTransform: "none" as "none",
        padding: "14px 0px",
        whiteSpace: "pre" as "pre",
        "&:hover": {
            border: "2px solid lavender",
            background: "#007000",
            color: 'white',
        },
    },
    primaryBackground: {
        color: "white",
        backgroundColor: theme.palette.primary.main,
    },
    seagreen: {
        color: 'seagreen',
    },
    primary: {
        color: theme.palette.primary.main
      },
      font: {
        fontSize: "1rem"
      },
        icon:{
            width: "30px",
            height: "30px",
            paddingBottom: "5px"
          },
          padding: {
            //whiteSpace: "pre" as "pre",
            paddingRight: "8px",
            margin: "auto 0"
        },
        primaryTextField: {
            color: theme.palette.primary.main,
            backgroundColor: "white",
            textAlign: 'left' as 'left',
        },
        gutterBottom: {
          marginBottom: '0.35em',
      },
});

// połączenie z Redux
const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});



export default connect(mapStateToProps)(withStyles(styles)(Hotel));